import {CommonModule} from '@angular/common';
import {Component, OnInit, signal} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FarmUserServiceService} from '@services/farm-user-service.service';
import {LoaderService} from '@services/loader.service';
import {UserRoleService} from '@services/user-role.service';
import {CountryListComponent} from 'ngx-countries-dropdown';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-edit-farm-user',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, CountryListComponent],
    templateUrl: './edit-farm-user.component.html',
    styleUrl: './edit-farm-user.component.scss'
})
export class EditFarmUserComponent implements OnInit {
    public userForm: FormGroup;
    public currentDate: string;
    public classifications: any[] = [];
    public roles: any[] = [];
    public chickTypes: any[] = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public UserDetail: any;
    public userId: number;
    public selectedCountryCode: string;
    public showPassword: boolean = false;

    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private farmUserService: FarmUserServiceService,
        private userRoleService: UserRoleService,
        private router: Router,
        private routes: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.userId = this.routes.snapshot.params['id'];
        this.UserDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.userForm = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(2)]],
            phone: ['', [Validators.required, Validators.pattern(/^05\d{8}$/)]],

            employeeId: ['', Validators.required],
            roleId: ['', Validators.required],
            countryCode: [''],
            email: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                    )
                ]
            ],
            password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.pattern(
                        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^a-zA-Z0-9]).{8,}$'
                    )
                ]
            ],
            parantUserId: this.UserDetail.id
        });
        this.getRoleList();
        if (this.userId) {
            this.GetuserDetailById(this.userId);
        }
    }
    onCountryChange(event: any) {
        this.userForm.patchValue({countryCode: event.code});
    }
    getRoleList() {
        this.userRoleService.getRoleList().subscribe((result) => {
            this.roles = result;
        });
    }

    onSubmit(): void {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        if (this.userForm.valid || this.userForm.value.password == null) {
            const userdata = {
                ...this.userForm.value,
                phone: String(this.userForm.value.phone),
                id: this.userId
            };

            this.farmUserService.updateUserDetail(userdata).subscribe({
                next: (response) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.success('user detail Updated Successfully');
                        this.userForm.reset;
                    }, 2000);
                    this.router.navigate(['/farm-user-list']);
                },
                error: (error) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.error(error.error);
                    }, 2000);
                }
            });
        } else {
            this.loaderService.hideLoader();
            this.userForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
        }
    }

    get f() {
        return this.userForm.controls;
    }

    GetuserDetailById(UserId: any) {
        this.farmUserService
            .getUserDetailById(UserId)
            .subscribe((response: any) => {
                this.userForm.patchValue(response);
                this.selectedCountryCode = response.countryCode;
            });
    }

    onClose(): void {
        this.router.navigate(['/farm-user-list']);
    }

    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }
}
